export default "__VITE_ASSET__Dl3WI$GH__"